export const PAYMENT_METHOD = {
  CREDIT_CARD: 1,
  BANK_TRANSFER: 2,
};
